"use strict";
var myminxin = {
    data: function () {
        return {
            is_storage: true,
            newer_gift: [],  //新用户礼品数据
            gift_image: '', // 新用户礼品图片
            newer_lingqu_show: false, // 用户是否领取
            newer_modal_show: false,  // 新用户大礼包是否显示
            popup_modal_box: false,  // 是否显示广告
            popupData: '',  //广告数据
            ispopupData: false,  //该课程是否显示广告
            showPopupNum: localStorage.getItem('showPopupNum') === '2' ? false : true,  //弹窗数量（每天最多弹2个） 弹窗顺序：新用户礼包 > 直播课程弹窗 > 广告弹窗（每天最多弹2个）
            isCollect: false,
            sharembc: false,
            openshare: 1,
            showerma: '',
            shareData: '', // 分享领红包相关数据
            toCopy: true,
            islogin:false,

            // 福气值
            isBlessing: false,
            seconds: 20,
            blessingTip: '',
            blessingTimer: null
        };
    },
    created: function created() {
        var _this = this

        if (!_this.getCookie('uid') && !_this.getCookie('token')) {
            var _this = this
            _this.islogin = false;
        } else {
            _this.islogin = true;
        }

        _this.popupMess();

        if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
            _this.is_storage = true;
        }
        var newer_last_time = ''
        if (_this.is_storage) {
            newer_last_time = localStorage.getItem('newer_last_time'); // 获取用户关闭大礼包的时间
        } else {
            newer_last_time = _this.getCookie('newer_last_time');
        }

        var now_time = (new Date()).valueOf(); // 用户关闭大礼包的时间

        var uid = _this.getCookie('uid');

        // 未登陆
        if (!uid) {

            // 判断是否超了24小时 -- 新人礼包
            if (!newer_last_time || now_time - newer_last_time > 86400000) {
                _this.newer_modal_show = true;
                _this.popup_modal_box = false;

            } else {

                // 首页有直播课程时， showPopupNum 值为 false
                if(_this.showPopupNum) {
                    _this.popup_modal_box = true;
                }

                // if (localStorage.getItem('isshowPopup') !== '0' && _this.showPopupNum) {
                //     _this.popup_modal_box = true;
                // }
            }

        } else {
            // var uid = _this.getCookie('uid');
            $.ajax({
                type: 'get',
                url: API + '/sys/user/new_user_status',
                dataType: 'json',
                xhrFields: {withCredentials: true}
            }).success(function (res) {
                if (res.errno == 0) {
                    if(res.data.status == 1){
                        _this.newer_modal_show = true;
                        // _this.popup_modal_box = false;
                        _this.newer_lingqu_show = true;
                    } else {
                        // if (localStorage.getItem(uid + 'popup') !== uid) {
                        //     _this.popup_modal_box = true;
                        // }
                        // if (localStorage.getItem('isshowPopup') !== '0' && _this.showPopupNum) {
                        //     _this.popup_modal_box = true;
                        // }

                        // 首页有直播课程时， showPopupNum 值为 false
                        if(_this.showPopupNum) {
                            _this.popup_modal_box = true;
                        }
                    }
                }
            });
        }
        this.judgeIsReceiveBlessing();
    },

    /* mounted () {
      this.$nextTick(() => {
        document.addEventListener('keydown', (e) => {
            var ctrl = e.ctrlKey;
            var meta = e.metaKey;
            var key = e.keyCode;
            if((ctrl || meta) && key === 68) {
                if (this.is_storage) {
                    localStorage.setItem('isCollect', 1);
                } else {
                    this.setCookie('isCollect', 1);
                }
            }
        })
      });
    }, */

    methods: {
        // 判断是否已领取过福气值
        judgeIsReceiveBlessing() {
            if(this.getParam('blessing')) {
                var _this = this;
                _this.isBlessing = true;
                $.ajax({
                    url: FAST + '/sys/user/blessing',
                    type: 'GET',
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function success(res) {
                        let onlyOne = false;
                        if(res.code === 4030 || res.data === 4040) {
                            location.href="http://passport.julyedu.com/login?redirect=" + encodeURI(document.URL);
                        }else if(res.code === 200) {
                            var list = res.data.today_browsed_courses;
                            if(list.length <= 0) {
                                _this.isShowBlessingPopup();
                            }else {
                                for(var i=0; i<list.length; i++) {
                                    if(list[i] == course_id) {
                                        onlyOne = false;
                                        break;
                                    }else {
                                        onlyOne = true;
                                    }
                                }
                                if(onlyOne) {
                                    _this.isShowBlessingPopup();
                                }else {
                                    _this.blessingTip = '任务完成';
                                }
                            }
                        }
                    }
                })
            }
        },

        // 是否展示福气弹窗
        isShowBlessingPopup: function() {
            var _this = this;
            _this.blessingTimer = setInterval(function() {
                if(_this.seconds > 0) {
                    _this.seconds = _this.seconds - 1;
                }else {
                    clearInterval(_this.blessingTimer);
                    $.ajax({
                        url: FAST + '/sys/add/blessing',
                        type: 'POST',
                        dataType: 'json',
                        data: {
                            type: 4,
                            course_id: course_id
                        },
                        xhrFields: {
                            withCredentials: true
                        },
                        success: function success(data) {
                            if (data.code === 200) {
                                _this.blessingTip = '任务完成';
                            }
                        }
                    });
                }
            }, 1000);
        },

        // 获取url参数
        getParam: function (key, str) {
            const _s = str ? str : location.href;
            const re = new RegExp(`(?:\\?|#|&)(${key})=([^=&#\\?]+)`, 'ig');
            let found;
            return (found = re.exec(_s)) ? found[2] : null;
        },


        getCookie: function getCookie(name) {
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg)) {
                return unescape(arr[2]);
            } else {
                return null;
            }
        },

        setCookie: function setCookie(cname, cvalue, exdays) {
            if(exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                var expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + "; " + expires;
            }else {
                document.cookie = cname + "=" + cvalue + "; ";
            }
        },

        // 获取大礼包、广告信息
        popupMess: function popupMess() {
            var _this = this
            $.ajax({
                type: 'get',
                url: API + '/web/home/popup?course_id='+course_id,
                dataType: 'json',
            })
                .success(function (res) {
                    if (res.errno === 200) {
                        // if (res.data.new_user_gift) {
                        //     _this.newer_gift = res.data.new_user_gift;
                        // }
                        _this.gift_image = res.data.new_user_gift.prize_img;

                        if (res.data.ad_popup.length === 0) {
                            _this.ispopupData = false;
                        } else {
                            _this.ispopupData = true;
                            _this.popupData = res.data.ad_popup;
                        }
                    }
                });

        },

        // 点击大礼包领取按钮
        get_newerModal: function get_newerModal() {
            var now_time = (new Date()).valueOf(); // 获取当前时间

            if (this.is_storage) {
                localStorage.setItem('newer_last_time', now_time);  // 存储当前时间
            } else {
                this.setCookie('newer_last_time', now_time, 1);
            }

            window.location.href = PASSPORT + "/reg/";

        },

        // 关闭大礼包
        close_newerModal: function close_newerModal() {
            var _this = this;
            _this.newer_modal_show = false;
            // var uid = _this.getCookie('uid');
            var now_time = (new Date()).valueOf(); // 获取当前时间
            if (this.is_storage) {
                localStorage.setItem('newer_last_time', now_time);  // 存储当前时间
            } else {
                this.setCookie('newer_last_time', now_time, 1);
            }

            // if ((!uid && localStorage.getItem('isshowPopup') !== '0') || (uid && localStorage.getItem(uid + 'popup') !== uid)) {
            // if ((localStorage.getItem('isshowPopup') !== '0') && _this.showPopupNum) {
            //     _this.popup_modal_box = true;
            // }

            // 首页有直播课程时， showPopupNum 值为 false
            if(_this.showPopupNum) {
                if(!_this.ispopupData) {
                    // _this.isCollect = true;
                }else {
                    _this.popup_modal_box = localStorage.getItem('isshowPopup') !== '0'? true : false;
                }
            }
        },

        // 关闭广告
        popupClose: function popupClose() {
            var _this = this;
            _this.popup_modal_box = false;
            // var uid = _this.getCookie('uid');

            if (this.is_storage) {
                localStorage.setItem('isshowPopup', 0);
                // if (!uid) {
                //     localStorage.setItem('isshowPopup', 0);
                // } else {
                //     localStorage.setItem(uid + 'popup', uid);
                // }
            } else {
                this.setCookie('isshowPopup', '0', 1);
                // if (!uid) {
                //     this.setCookie('isshowPopup', '0', 86400);
                // } else {
                //     this.setCookie(uid + 'popup', uid, 86400);
                // }
            }
        },

        // 点击背景图、配图跳转
        popupHrefBgimg:function popupHrefBgimg(){
            this.popupClose();
        },

        collectEvent: function collectEvent(isColse) {
            if(isColse) {
                // 知道
                var date =  new Date()
                var seconds = date.getTime();
                if (this.is_storage) {
                    localStorage.setItem('collectTime', seconds);
                    localStorage.setItem('isCollect', 0);
                } else {
                    this.setCookie('collectTime', seconds, 1);
                    this.setCookie('isCollect', 0);
                }
            }else {
                // 已收藏
                if (this.is_storage) {
                    localStorage.setItem('isCollect', 1);
                } else {
                    this.setCookie('isCollect', 1);
                }
            }
            this.isCollect = false;
        },

        // 分享领红包
        sharecode: function sharecode() {
            var _this = this;
            if (_this.islogin) {
                _this.sharembc = true;
                _this.openshare = 1;
                $.ajax({
                    type: 'get',
                    url: `${FAST}/sys/redPacket/shareUrl/${course_id}`,
                    xhrFields: {
                        withCredentials: true
                    }
                }).done(res => {
                    if (res.code == 200) {
                        _this.shareData = res.data
                        setTimeout(function () {
                            new QRCode(document.getElementById("shareqrcode"), {
                                render: 'canvas',
                                text:  _this.shareData.url,
                                width: 90,
                                height: 90,
                                colorDark: '#000000',
                                //前景色
                                colorLight: '#ffffff' //背景色

                            });
                        }, 20);
                    } else if(res.code == 4030 || res.code == 4040){
                        window.location.href = PASSPORT + "/login?redirect=" + encodeURIComponent(document.URL);
                    }
                });


            } else {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURIComponent(document.URL);
            }
        },

        // 复制分享领红包的口令
        copyCommand: function copyCommand() {
            this.toCopy = false
            this.$refs.copyEle.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
        },

        // 引导关注公众号
        closeShare: function closeShare() {
            var _this = this;
            if(_this.shareData.is_follow == 0){
                _this.openshare = 2;
                _this.followService();
            } else {
                _this.sharembc = false;
            }
        },

        // 关闭弹窗
        closeShare2: function closeShare() {
            var _this = this;
            _this.sharembc = false;
        },

        // 关注服务号
        followService: function followService() {
            var _this = this;

            var uid = _this.getCookie('uid');
            $.ajax({
                type: 'get',
                url: API + '/wx/user_temporary_qrcode/' + uid,
                dataType: 'json',
                success: function success(data) {
                    _this.showerma = data.data.qr_image;
                    // setTimeout(function () {
                    //     new QRCode(document.getElementById("service_erweima"), data.data.qr_image);
                    // });
                }
            });
        },

        // 课程详情页大纲试听按钮，临时放在这儿，之后需要放在newdetail.js
        easy_get_class_audition:function easy_get_class_audition(video_id) {
            var _this= this
            if (!_this.getCookie('uid') && !_this.getCookie('token')) {
                window.location.href = PASSPORT + "/login?redirect=" + encodeURI(document.URL);
                return;
            }
            if(video_id == '' || video_id == 0 || video_id == undefined){
                return false;
            }

            $.ajax({
                url: API + '/sys/get_class_audition?video_id='+video_id,
                type: 'post',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function success(data) {
                    if (data.errno == 200) {
                        window.location.href = "/video/play/" + window.v_course_id + "/" + video_id;
                    }else{
                        alert(data.msg);
                    }
                }
            });
        }
    }
}